module.exports = __webpack_public_path__ + "static/img/buddy_pictgrid26_920x865.d9bdbe3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/buddy_pictgrid26_920x865.jpg
// module id = NhpH
// module chunks = 0